import styled, { css } from 'styled-components';
import { userModel } from '@_entities/user';

export const IconWrapper = styled.div<{ type: userModel.TUser['social']; size: string }>`
	width: ${({ size }) => size};
	height: ${({ size }) => size};
	position: relative;

	${({ type }) => {
		switch (type) {
			case 'apple':
				return css`
					background-color: black;
				`;
			case 'google':
				return css`
					background-color: white;
					border: 1px solid #e6e6ea;
				`;
			case 'kakao':
				return css`
					background-color: #ffe812;
				`;
			case 'naver':
				return css`
					background-color: #00bf18;
				`;
			default:
				return css``;
		}
	}}

	display: inline-flex;
	justify-content: center;
	align-items: center;
	border-radius: 100%;

	svg {
		${({ type }) => {
			switch (type) {
				case 'apple':
					return css`
						width: 80%;
					`;
				case 'google':
					return css`
						width: 50%;
					`;
				case 'kakao':
					return css`
						width: 100%;
					`;
				case 'naver':
					return css`
						width: 40%;
					`;
				default:
					return css``;
			}
		}}
		flex-shrink:0;
	}
`;
